/* eslint-disable import/no-extraneous-dependencies */
import styled from 'styled-components';

export const Title = styled.h1`
  color: #464646;
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 0.75rem;
`;
